"use strict";

/**
 * @file
 * Will provide responsive menu custom functionality.
 */
(function ($) {
    "use strict";

    Drupal.behaviors.navBehavior = {
        attach: function (context) {
            let li = $(context).find('#block-konvoy-york-main-menu .york-menu-content > ul > li');
        
            li.on('mouseover', function(e) {
                if($(window).width() > 1199) {
                    $('.content-region').removeClass('menu-active--mouseout');
                    let subHeight = parseInt($(this).find('ul').css('height')) + parseInt($(this).height());
                    $(this).css('height', subHeight);
                    $('.content-region').addClass('menu-active');
                }
            });
            li.on('mouseout', function(e) {
                if($(window).width() > 1199) {
                    $(this).css('height', 'auto');
                    $('.content-region').removeClass('menu-active');
                    $('.content-region').addClass('menu-active--mouseout');
                }
            });
            

            let menuButton = $('.york-menu-button');
            let menuContent = $('.york-menu-content');
            menuButton.on('click', function(e) {
                menuButton.toggleClass('menu-open');
                menuContent.toggleClass('menu-open');
            });
        }
    }

    $('.area--am-landschaftspark-york').on('mouseover', function(){ $('.wrapper--am-landschaftspark-york').css('transform', 'scale(1.5,1.5)') });
    $('.area--am-landschaftspark-york').on('mouseout', function(){ $('.wrapper--am-landschaftspark-york').css('transform', 'scale(1,1)') });
    $('.area--secret-garden').on('mouseover', function(){ $('.wrapper--secret-garden').css('transform', 'scale(1.5,1.5)') });
    $('.area--secret-garden').on('mouseout', function(){ $('.wrapper--secret-garden').css('transform', 'scale(1,1)') });
    $('.area--gartenwohnen').on('mouseover', function(){ $('.wrapper--gartenwohnen').css('transform', 'scale(1.5,1.5)') });
    $('.area--gartenwohnen').on('mouseout', function(){ $('.wrapper--gartenwohnen').css('transform', 'scale(1,1)') });
    $('.area--gremmendorf-zentrum').on('mouseover', function(){ $('.wrapper--gremmendorf-zentrum').css('transform', 'scale(1.5,1.5)') });
    $('.area--gremmendorf-zentrum').on('mouseout', function(){ $('.wrapper--gremmendorf-zentrum').css('transform', 'scale(1,1)') });
    $('.area--casinopark-york').on('mouseover', function(){ $('.wrapper--casinopark-york').css('transform', 'scale(1.5,1.5)') });
    $('.area--casinopark-york').on('mouseout', function(){ $('.wrapper--casinopark-york').css('transform', 'scale(1,1)') });
    $('.area--panzerhallen-york').on('mouseover', function(){ $('.wrapper--panzerhallen-york').css('transform', 'scale(1.5,1.5)') });
    $('.area--panzerhallen-york').on('mouseout', function(){ $('.wrapper--panzerhallen-york').css('transform', 'scale(1,1)') });
    $('.area--wohnen-im-eigenen-haus').on('mouseover', function(){ $('.wrapper--wohnen-im-eigenen-haus').css('transform', 'scale(1.5,1.5)') });
    $('.area--wohnen-im-eigenen-haus').on('mouseout', function(){ $('.wrapper--wohnen-im-eigenen-haus').css('transform', 'scale(1,1)') });
    $('.area--yorkpark').on('mouseover', function(){ $('.wrapper--yorkpark').css('transform', 'scale(1.5,1.5)') });
    $('.area--yorkpark').on('mouseout', function(){ $('.wrapper--yorkpark').css('transform', 'scale(1,1)') });


    $('.gebiet').on('click', function(e) {
        let target = $(this).attr("data-target");
        console.log(target);
        $('#modal-' + target).addClass('visible');
    });
    $('.modal-close, .modaloverlay').on('click', function(e) {
        e.preventDefault();
        console.log( $(this) );
        $('.modalwrapper').removeClass('visible');
    });
}
)(jQuery);
